module.exports = __webpack_public_path__ + "media/images/logo-4e60eda298611ff6939e7f8da8673230.png";